import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const tenantWebhookMenuRegistry = {
    core_tenantWebhook: {
        label: "Tenant Webhooks",
        link: PAGE_URL.TENANT_WEBHOOK_PAGE,
        key: PAGE_URL.TENANT_WEBHOOK_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default tenantWebhookMenuRegistry;

